/*
 * Everyday Gourmet video mapping helper.
 *
 * Shared logic lives in /js/pixmoto_video_mapping_common.js.
 */
(() => {
  const mappingScriptEl = document.currentScript || null;
  function run() {
    if (!window.PixmotoVideoMapping) {
      return;
    }
    const runner = window.PixmotoVideoMapping.createRunner({
      runtimePrefix: "EG",
      // Everyday Gourmet is Squarespace 7.1 (same template family as
      // Good Chef Bad Chef). Two target selectors, checked in priority
      // order (first with a match wins):
      //   1. `.intrinsic` — the post-hydration `<figure>` aspect-ratio
      //      wrapper Squarespace injects around a classic image/embed
      //      block. Present on recipes whose hero media block is fully
      //      hydrated (YouTube embed or classic image).
      //   2. `[data-sqsp-image-classic-block-image-container]` — the bare
      //      classic-image-block container. On image-only recipes the
      //      hero renders WITHOUT the `.intrinsic` figure wrapper, so #1
      //      finds nothing; this fallback maps the image container itself.
      //      It already carries an inline `padding-bottom` aspect ratio,
      //      which the runner's `ensureAspectRatio` preserves.
      // On pages where #1 matches, #2 is never consulted (the figure
      // contains the container), so this can't double-map.
      targetSelector: [
        ".intrinsic",
        "[data-sqsp-image-classic-block-image-container]",
      ],
      // Remove the duplicate "WATCH HOW TO MAKE IT" YouTube button block once
      // the Pixmoto experience is placed. Whole `.sqs-block-button` block (not
      // just the <a>) so no empty button gap is left; the exact href differs
      // per recipe, so match any YouTube-linked button block.
      removeSelectors: ['.sqs-block-button:has(a[href*="youtu"])'],
      scriptElement: mappingScriptEl,
    });
    runner();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
